import axios from 'axios';

if(location.hostname === 'localhost') {
    console.log('Running locally');
    axios.defaults.baseURL = 'http://192.168.168.202:10000/';    
}

export default {    
    async getAppointmentTimesByDate(location, date, service) {
        var dateFormatted = (date.getMonth() + 1) + '-' + (date.getDate()) + '-' + (date.getFullYear());
        var getUrl  = "api/scheduling/appointments/" + location + '/available/date/' + dateFormatted + '/' + service;                
        
        try {
            var response = await axios.get(getUrl, { headers: { 'Content-Type': 'application/json'} });
            
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in getting times');
                return null;
            }
        } catch(e) {
            await new Promise((resolve) => setTimeout(() => resolve(), 5000));
            return ['10:00 AM', '12:00 PM', '12:30 PM', '1:00 PM', '3:00 PM' ];
        }

    },
    async scheduleAppointment(person, appointmentTime, locationId, service, serviceDescription, staffMember, notes) {
        var putUrl = "api/scheduling/appointments/online";        

        var data = {};
        data.locationId = locationId;
        data.scheduledStart = appointmentTime;
        data.person = person;
        data.service = service;
        data.serviceDescription = serviceDescription;
        data.StaffMember = staffMember;
        data.PaymentToken = notes;
        
        var jsonData = JSON.stringify(data);
        
        console.log('app data', data);
        try {
            var response = await axios.put(putUrl, jsonData, { headers: { 'Content-Type': 'application/json'} });
            
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in scheduling');
                return null;
            }
        }
        catch(e) {
            await new Promise((resolve) => setTimeout(() => resolve(), 5000));
            return false;
        }
    },
    async verifyMembership(person) {
        var putUrl = "api/scheduling/verifymember";        

        var data = {};        
        data = person;

        var jsonData = JSON.stringify(data);
        
        console.log('app data', data);
        try {
            var response = await axios.post(putUrl, jsonData, { headers: { 'Content-Type': 'application/json'} });
            
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in scheduling');
                return "0";
            }
        }
        catch(e) {
            await new Promise((resolve) => setTimeout(() => resolve(), 5000));
            return "0";
        }
    },
    async cancelAppointment(reference, email) {
        var postUrl = "api/scheduling/cancel";        

        var data = {};
        data.email = email;
        data.appointmentId = reference;

        var jsonData = JSON.stringify(data);
        
        console.log('app data', data);
        try {
            var response = await axios.post(postUrl, jsonData, { headers: { 'Content-Type': 'application/json'} });
            
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in cancel');
                return null;
            }
        } catch(e) {
            return null;
        }

    },
    async verifyAppointment(reference, email) {
        var postUrl = "api/scheduling/verify";        

        var data = {};
        data.email = email;
        data.appointmentId = reference;

        var jsonData = JSON.stringify(data);
        
        console.log('app data', data);
        try {
            var response = await axios.post(postUrl, jsonData, { headers: { 'Content-Type': 'application/json'} });
            
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in cancel');
                return null;
            }
        } catch(e) {
            return null;
        }

    },
    async changeAppointment(reference, newDate, locationId) {
        var postUrl = "api/scheduling/change";        

        var data = {};
        data.appointmentId = reference;
        data.newDate = newDate;
        data.locationId = locationId;

        var jsonData = JSON.stringify(data);
        
        console.log('app data', data);
        try {
            var response = await axios.post(postUrl, jsonData, { headers: { 'Content-Type': 'application/json'} });
            
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in cancel');
                return null;
            }
        } catch(e) {
            return null;
        }
    },
    async getLocations() {
        var getUrl  = "api/environment/locations";                
        
        try {
            var response = await axios.get(getUrl, { headers: { 'Content-Type': 'application/json'} });
            
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in getting locations');
                return null;
            }
        } catch(e) {
            await new Promise((resolve) => setTimeout(() => resolve(), 5000));
            return [
                {
                    "id": 1,
                    "name": "Glastonbury",
                    "address": "81 House St",
                    "city": "Glastonbury",
                    "state": "CT",
                    "zipCode": "06033",
                    "phoneNumber": null,
                    "saturdayOpenTime": "00:00:00",
                    "saturdayCloseTime": "00:00:00",
                    "sundayOpenTime": "00:00:00",
                    "sundayCloseTime": "00:00:00",
                    "mondayOpenTime": "00:00:00",
                    "mondayCloseTime": "00:00:00",
                    "tuesdayOpenTime": "00:00:00",
                    "tuesdayCloseTime": "00:00:00",
                    "wednesdayOpenTime": "00:00:00",
                    "wednesdayCloseTime": "00:00:00",
                    "thursdayOpenTime": "00:00:00",
                    "thursdayCloseTime": "00:00:00",
                    "fridayOpenTime": "00:00:00",
                    "fridayCloseTime": "00:00:00",
                    "maxAppointmentsPerWindow": 0,
                    "maxScheduleAheadDays": 0,
                    "minutesBeforeFirstAppointment": 0,
                    "stripeKey": null,
                    "minutesForLastAppointmentBeforeClose": 0,
                    "availableServices": [
                        {
                            "id": 0,
                            "description": "Notary",
                            "coreId": "NOT"
                        },
                        {
                            "id": 0,
                            "description": "Signing of Loan Docs",
                            "coreId": "LND"
                        },
                        {
                            "id": 0,
                            "description": "Account / Loan Maintenance",
                            "coreId": "MNT"
                        }
                    ]
                },
                {
                    "id": 2,
                    "name": "Rocky Hill 520",
                    "address": "520 Cromwell Ave",
                    "city": "Rocky Hill",
                    "state": "CT",
                    "zipCode": "06067",
                    "phoneNumber": null,
                    "saturdayOpenTime": "00:00:00",
                    "saturdayCloseTime": "00:00:00",
                    "sundayOpenTime": "00:00:00",
                    "sundayCloseTime": "00:00:00",
                    "mondayOpenTime": "00:00:00",
                    "mondayCloseTime": "00:00:00",
                    "tuesdayOpenTime": "00:00:00",
                    "tuesdayCloseTime": "00:00:00",
                    "wednesdayOpenTime": "00:00:00",
                    "wednesdayCloseTime": "00:00:00",
                    "thursdayOpenTime": "00:00:00",
                    "thursdayCloseTime": "00:00:00",
                    "fridayOpenTime": "00:00:00",
                    "fridayCloseTime": "00:00:00",
                    "maxAppointmentsPerWindow": 0,
                    "maxScheduleAheadDays": 0,
                    "minutesBeforeFirstAppointment": 0,
                    "stripeKey": null,
                    "minutesForLastAppointmentBeforeClose": 0,
                    "availableServices": [
                        {
                            "id": 0,
                            "description": "Notary",
                            "coreId": "NOT"
                        },
                        {
                            "id": 0,
                            "description": "Withdrawal Cash over ATM Limit",
                            "coreId": "WCA"
                        },
                        {
                            "id": 0,
                            "description": "Signing of Loan Docs",
                            "coreId": "LND"
                        },
                        {
                            "id": 0,
                            "description": "Account / Loan Maintenance",
                            "coreId": "MNT"
                        },
                        {
                            "id": 0,
                            "description": "Check Deposits of 5 or More Checks",
                            "coreId": "5CK"
                        },
                        {
                            "id": 0,
                            "description": "Print a Debit/Credit Card",
                            "coreId": "CRD"
                        }
                    ]
                }
            ]
        }
    }
}